// src/app/guards/auth-redirect.guard.ts
import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs/operators';

export const authRedirectGuard: CanActivateFn = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.checkAuth().pipe(
    map(({ isAuthenticated }) => {
      if (isAuthenticated) {
        router.navigate(['/client/cards/']);
      } else {
        router.navigate(['/auth/client/cards/']);
      }
      return false; // detener la navegación en esta ruta
    })
  );
};
